<template>
    <div class="container">
        <div v-if="loading" style="height:100%;text-align:center;">
            <h4>Loading</h4>
            <div class="preloader-wrapper small active">
                <div class="spinner-layer">
                    <div class="circle-clipper left">
                        <div class="circle"></div>
                    </div>
                    <div class="gap-patch">
                        <div class="circle"></div>
                    </div>
                    <div class="circle-clipper right">
                        <div class="circle"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col s12">
                <div class="center-align">
                    <h5 class="bold title">Enter the quantity of parts desired on the build plate</h5>
                    <table class="highlight">
                        <thead>
                        <tr>
                            <th class="remove-file"></th>
                            <th>File</th>
                            <th class="quantity">Desired Quantity</th>
                            <!--<th class="importance">Relative Importance of Part Quantity</th>-->
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(file, pathKey) of filesNested" :key="file.id">
                            <td>
                                <i class="material-icons a3d color"
                                   style="cursor:pointer;"
                                   @click="removeFile(file)">clear</i>
                            </td>
                            <td>
                                <div class="filename">{{file.name}}</div>
                            </td>
                            <td><input type="number"
                                       min="1"
                                       :value="file.quantity"
                                       @input="updateQuantity(pathKey, $event)">
                                <div class="error" v-if="file.quantity < 1">Quantity should be greater than 0</div>
                            </td>
                            <!--<td><input type="range"
                                       min="0"
                                       max="1"
                                       step="0.01"
                                       :value="file.importance"
                                       @change="updateImportance(pathKey, $event)"></td>-->
                        </tr>
                        </tbody>
                    </table>
                    <div v-if="submitting" class="progress">
                        <div class="indeterminate">
                        </div>
                    </div>
                    <div class="block-buttons">
                        <button class="a3d btn inv" @click="goBack()" :disabled="submitting">Back</button>
                        <button class="a3d btn" @click="goNext()" :disabled="submitting">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import errorHandling from '../mixins/errorHandling'

  export default {
    mixins: [errorHandling],
    data: function () {
      return {
        parentPathKey: null,
        loading: false,
        submitting: false,
        continueJob: false
      }
    },
    computed: {
      ...mapState([
        'filesNested'
      ])
    },
    methods: {
      ...mapActions([
        'setNestedFile',
        'updateNestedJob',
        'setNestedFileData',
        'getNestedJobs'
      ]),
      init () {
        this.parentPathKey = this.getParentPathKey()
        if (this.continueJob) {
          this.loading = true
          this.getNestedJobs(this.parentPathKey)
            .then((response) => {
              if (response && response.data.allJobs && response.data.allJobs.length > 0) {
                this.setNestedFileData(response.data.allJobs)
                this.loading = false
              }
            })
            .catch((err) => {
              this.loading = false
              this.errorHandling(err, this.init)
            })
        } else {
          if (Object.keys(this.filesNested).length < 1) {
            this.$router.push({name: 'Dash'})
          }
        }
      },
      getParentPathKey () {
        if (this.$route.params.id) {
          this.continueJob = true
          return this.$route.params.id
        } else if (Object.keys(this.filesNested).length > 0) {
          return this.filesNested[Object.keys(this.filesNested)[0]].parentPathKey
        } else {
          return null
        }
      },
      validate () {
        let valid = true
        Object.keys(this.filesNested).forEach((key) => {
          if (this.filesNested[key].quantity < 1) {
            valid = false
          }
        })
        return valid
      },
      goBack () {
        this.$router.replace({name: 'Dash'})
      },
      goNext () {
        if (this.validate()) {
          if (this.parentPathKey) {
            this.submitting = true
            const nestedConfig = []
            Object.keys(this.filesNested).forEach((key) => {
              nestedConfig.push({
                importance: this.filesNested[key].importance,
                quantity: this.filesNested[key].quantity,
                jobPathKey: this.filesNested[key].jobPathKey
              })
            })
            this.updateNestedJob({
              nestedJobs: nestedConfig,
              parentPathKey: this.parentPathKey
            }).then((response) => {
              this.submitting = false
              this.$router.push({name: 'NestedCreateById', params: {id: this.parentPathKey}})
            })
              .catch((err) => {
                this.submitting = false
                this.errorHandling(err, this.goNext)
              })
          } else {
            this.$router.push({name: 'NestedCreate'})
          }
        }
      },
      removeFile (file) {
        this.setNestedFile(file)
        if (Object.keys(this.filesNested).length < 1) {
          this.$router.replace({name: 'Dash'})
        }
      },
      updateQuantity (pathKey, $event) {
        this.$store.commit('UPDATE_DESIRED_QUANTITY', {pathKey, value: $event.target.value})
      },
      updateImportance (pathKey, $event) {
        this.$store.commit('UPDATE_RELATIVE_IMPORTANCE', {pathKey, value: $event.target.value})
      }
    },
    beforeMount () {
      this.init()
    }
  }
</script>

<style lang="scss" scoped>
    .container {
        .title {
            padding: 1em 0;
        }

        table.highlight {
            .quantity {
                width: 20%;
                min-width: 100px;
            }

            .importance {
                width: 33%;
                min-width: 200px;
            }
            .remove-file {
                width: 48px;
            }

            td {
                padding: 15px 12px;
                border-bottom: 1px solid #d0d0d0;

                .filename {
                    word-break: break-all;
                }

                input[type="number"], input[type="text"] {
                    box-sizing: border-box;
                    background-color: #fff;
                    padding: 0 12px;
                    margin: 0;
                }

                .error {
                    color: #ff0000;
                }
            }
        }

        .block-buttons {
            padding-top: 1em;
        }
    }
</style>



// WEBPACK FOOTER //
// Nested.vue?201dd615